import { Component } from "react";
import { withNamespaces } from "react-i18next";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import { Reveal } from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import { Icon } from "@iconify/react";
import Skeleton from "react-loading-skeleton";
import moment from "moment";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { isDesktop } from "react-device-detect";

//Components
import ProfileSideBar from "../../Profile/ProfileSideBar/ProfileSideBar";
import Rebate from "./Rebate";
import History from "./History";
import DateTimePicker from "../../../components/DateTimePicker/DateTimePicker";
import Button from "../../../components/Button/Button";

// Actions
import * as actions from "../../../store/ducks/instantRebate/actions";
import { MobileInstantRebate } from "./MobileInstantRebate";

const filterDate = [
    { id: "filterToday", value: "0", label: "today" },
    { id: "filterYtd", value: "1", label: "yesterday" },
    { id: "filter7Day", value: "7", label: "last-7-days" },
    { id: "filter30Days", value: "30", label: "last-30-days" },
];

class InstantRebate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      historyTab: (props.location.state && props.location.state.historyTab) ? props.location.state.historyTab : 'history',
      defaultTab: (props.location.state && props.location.state.defaultTab) ? props.location.state.defaultTab : 0,
      currentFilterDate: 0,
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
      transaction_date: '',
      disableSearchButton: false,

      pageShow: "instant-rebate",
      total_instant_rebate: 0,
      rebate: { activePage: 1, limit: 10, loading: false, data: [] },
      history: { activePage: 1, limit: 10, loading: false, data: [] },

      /* mobile */
      showDateSelect: false,
      showDate: '',
      selectedDate: '',
      spin: false
    };
    this.onInputChange = this.onInputChange.bind(this);
  }
  
  componentDidMount() {
    // Auto-load table on first visit
    const listingArr = this.getFilterArray("rebate");
    this.props.funcGetList(listingArr);
  }

  setTotalRebate = (amount) => {
    console.log("Setting total rebate:", amount);
    this.setState({ total_instant_rebate: amount });
  };

  // Build request payload for the API from current local pagination state
  getFilterArray = (tab) => {
    const { activePage, limit } = this.state[tab] || {};
    // Adjust keys to whatever your API expects
    return {
      activePage: activePage || 1,
      limit: limit || 10,
      // If your API needs dates, add them here — otherwise leave minimal
      // start_date: this.state.start_date,
      // end_date: this.state.end_date,
    };
  };

  handleClaimAll = () => 
  {
      const { t } = this.props;

      // Early guard: nothing to claim
      const currentAmount = parseFloat(this.state.total_instant_rebate || 0);
      if (!currentAmount || currentAmount <= 0) {
        Swal.fire({
          iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:close-circle.svg?color=%23ffffff">' : '',
          title: t("global.failed"),
          icon: "error",
          text: t("instant-rebate.no-claim"),
          confirmButtonText: t("global.ok"),
          allowEnterKey: false,
          customClass: (!isDesktop) ? {
              container: "swal-mobile-container failed",
              icon: "swal-failed-icon", 
          } : [],
        });
        return;
      }

      const payload = {
        // If your backend reads member/merchant/country from auth you can omit these.
        member_id: this.props.member_id,
        merchant_id: this.props.merchant_id,
        country_id: this.props.country_id,
      };
      Swal.fire({
          iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:exclamation.svg?color=%23ffffff">' : '',
          title: t("global.reminder"),
          icon: "warning",
          text: t("instant-rebate.reminder-desc") + " MYR" + parseFloat(this.state.total_instant_rebate).toFixed(2) + t("instant-rebate.reminder-desc-1"),
          showCancelButton: true,
          confirmButtonText: t("instant-rebate.yes-claim-all"),
          cancelButtonText: t("instant-rebate.not-now"),
          allowEnterKey: false,
          customClass: (!isDesktop) ? {
              container: "swal-mobile-container failed",
              icon: "swal-failed-icon", 
          } : [],
        }).then((result) => 
        {
          if (result.isConfirmed) 
          {
            Swal.fire({
                title: "",
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            this.props.funcClaimAll(payload)
            .then(() => {
              this.setState({ total_instant_rebate: 0 });
              Swal.close();
              // Success message
              Swal.fire({
                iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:check-circle.svg?color=%23ffffff">' : '',
                title: t("global.success"),
                icon: "success",
                text: t("instant-rebate.claim-success"),
                confirmButtonText: t("global.ok"),
                customClass: !isDesktop
                  ? {
                        container: "swal-mobile-container sucess",
                        icon: "swal-success-icon",
                    }
                  : [],
                allowEnterKey: false
              });
            })
            .catch(() => {
              Swal.close();
              // Generic failure message
              Swal.fire({
                iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:close-circle.svg?color=%23ffffff">' : '',
                title: t("global.failed"),
                icon: "error",
                text: t("instant-rebate.claim-failed"),
                confirmButtonText: t("global.ok"),
                customClass: !isDesktop
                  ? {
                      container: "swal-mobile-container failed",
                      icon: "swal-failed-icon",
                    }
                  : [],
                allowEnterKey: false,
              });
            });
          }
        });
  }

  changeTabHandler = (e) => {
    e.preventDefault();
   const id = e.target.id;
    this.setState({ pageShow: id }, () => {
      // if (id === 'instant-rebate-history') {
      //   const listingArr = this.getFilterArray('history');
      //  this.props.funcGetList(listingArr);
      //  alert("history");
      // } else if (id === 'instant-rebate') {
      //   const listingArr = this.getFilterArray('rebate');
      //   this.props.funcGetList(listingArr);
      // }
    });
  };

  toggleShowDateSelect = (e, show) => {
    if (this.state.showDateSelect === false) {
        document.body.classList.add('modal-open');
    }
    else {
        document.body.classList.remove('modal-open');
    }
    this.setState({
        showDateSelect: !this.state.showDateSelect,
    });

    const startDate = moment(this.state.start_date);
    const endDate = moment(this.state.end_date);
    const diff = endDate.diff(startDate, 'days');
    
    this.setState({
        showDate: show,
        selectedDate: (show === 'startDate') ? this.state.start_date : this.state.end_date,
        disableSearchButton: (diff > 30) ? true : false,
    })
  }

  onChangeDateHandler = (value) => {
    if (this.state.showDate === 'startDate') {
        this.setState({
            start_date: `${value.years}-${value.months}-${value.days}`,
        })
    }
    else if (this.state.showDate === 'endDate') {
        this.setState({
            end_date: `${value.years}-${value.months}-${value.days}`,
        })
    }
  }

  onChangeFilterDateHandler = (value, e) => {
    this.setState({
        currentFilterDate: value
    });
  }

  onInputChange = (event) => {
    if (event.target.id === 'transaction_date') {
      const date = (event.target.value !== '') ? event.target.value.split(" - ") : null;
      this.setState({
        start_date: (date[0]) ? moment(date[0]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        end_date: (date[1]) ? moment(date[1]).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        transaction_date: event.target.value,
      });

      const startDate = moment(this.state.start_date);
      const endDate = moment(this.state.end_date);
      const diff = endDate.diff(startDate, 'days');

      // Only allow to get data between 30 days
      if (diff > 30) {
        this.setState({
          disableSearchButton: true
        })
      }
      else {
        this.setState({
          disableSearchButton: false
        })
      }
    }
  }

  searchHandler = (tab) => {
    let newFilter = { ...(this.state[tab] || {}) };
    newFilter.activePage = 1;
    newFilter.loading = true;

    this.setState({ 
      [tab]: newFilter, 
      disableSearchButton: false
    }, () => {
      const listingArr = this.getFilterArray(tab);
      if (tab === 'history') {
        this.props.funcGetHistoryList({
          ...listingArr,
          start_date: this.state.start_date,
          end_date: this.state.end_date,
          member_id: this.props.member_id,
          merchant_id: this.props.merchant_id,
          country_id: this.props.country_id,
        });
      } else {
        this.props.funcGetList(listingArr);
      }
    });
  }

  onResetHandler = () => {
    this.setState({
        defaultTab: 0,
        historyTab: 'history',
        currentFilterDate: 0,
        start_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        transaction_date: "",
        spin: true
    }, () => {
        const listingArr = this.getFilterArray("history");
        this.props.funcGetHistoryList({
            ...listingArr,
            start_date: moment().format("YYYY-MM-DD"),
            end_date: moment().format("YYYY-MM-DD"),
            member_id: this.props.member_id,
            merchant_id: this.props.merchant_id,
            country_id: this.props.country_id,
        });
    });

    setTimeout(() => this.setState({ spin: false }), 2000);
  }

  filterDayRange = (val) => {
      // let days = Number(event.target.value);
      let days = val;
      let startDate = moment().subtract(days, "days").format("YYYY-MM-DD");
      let endDate = moment().format("YYYY-MM-DD");
      let transactionDate = `${moment(startDate).format("MM/DD/YYYY")} - ${moment(endDate).format("MM/DD/YYYY")}`;

      this.setState({
          start_date: startDate,
          end_date: endDate,
          transaction_date: transactionDate,
          filterRange: days
      }, () => {
          let startDate = moment(this.state.start_date);
          let endDate = moment(this.state.end_date);
          let dayRange = endDate.diff(startDate, 'days');
          let disableButton = null;
          if (!startDate.isSameOrBefore(endDate) || !endDate.isSameOrAfter(startDate) || dayRange > 30) {
              disableButton = true;
          }
          else {
              disableButton = false;
          }
          this.setState({
              disableSearchButton: disableButton
          })

          this.searchHandler(this.state.historyTab);
      });
  }

  datatablesChangeHandler = (val, tab, act) => {
    let newFilter = Object.assign({}, this.state[tab]);
    newFilter[act] = (act === 'searchValue') ? val.target.value : val;
    newFilter['data'] = [];
    newFilter['loading'] = true;
    this.setState(
      (prev) => {
        const prevTab = prev[tab] || { activePage: 1, limit: 10 };
        return { [tab]: { ...prevTab, [act]: val, loading: true } };
      },
      () => {
        const listingArr = this.getFilterArray(tab);
        if (tab === 'rebate') {
          this.props.funcGetList(listingArr);
        } else if (tab === 'history') {
          this.props.funcGetHistoryList({
            ...listingArr,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            member_id: this.props.member_id,
            merchant_id: this.props.merchant_id,
            country_id: this.props.country_id,
          });
        }
      }
    );
  }
  
  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;

    const img = this.imageImport(require.context("../../../assets/images/profile/icons", false, /\.(png|jpe?g|svg)$/));
    const icon = this.imageImport(require.context("../../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));

    const fadeUp = keyframes`
      from {
        opacity: 0;
        transform: translate3d(0, 50px ,0);
      }

      to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
    `;

    return (
      <Auxiliary>
        {isDesktop ? (
          <section className="pf-dashboard">
              <div className="x-container">
                  <ProfileSideBar />
                  <Reveal className="pf-fade-col" keyframes={fadeUp} duration={1000} triggerOnce>
                      <div className="row g-3">
                        <div className="col-12">
                            <div className="pd-card-col">
                                <h4 className="mb-2">{t('instant-rebate.header')}</h4>
                                <p>{t('instant-rebate.desc')}</p>
                                <div className="pd-content">
                                  <div className="mt-3">
                                      <ul className="instant-rebate-tabs nav nav-tabs" role="tablist">
                                          <li className="nav-item" role="presentation">
                                              <button
                                                  className="nav-link active"
                                                  id="instant-rebate"
                                                  data-bs-toggle="tab"
                                                  data-bs-target="#rebate"
                                                  type="button"
                                                  role="tab"
                                                  aria-controls="rebate"
                                                  aria-selected="true"
                                                  onClick={(event) => this.changeTabHandler(event)}
                                              >
                                                  {t("instant-rebate.rebate")}
                                              </button>
                                          </li>

                                          <li className="nav-item" role="presentation">
                                              <button
                                                  className="nav-link"
                                                  id="instant-rebate-history"
                                                  data-bs-toggle="tab"
                                                  data-bs-target="#history"
                                                  type="button"
                                                  role="tab"
                                                  aria-controls="history"
                                                  aria-selected="false"
                                                  onClick={(event) => this.changeTabHandler(event)}
                                              >
                                                  {t("instant-rebate.history")}
                                              </button>
                                          </li>
                                      </ul>
                                  </div>
                                  <div className="row g-3 mt-2">
                                    {this.state.pageShow === "instant-rebate" && 
                                      <div className="col-6">
                                        <div className="total-ir-wrapper">
                                            <div className="total-ir-container w-100">
                                                <img className="active" src={img["instant-rebate.svg"]} alt="instant-rebate" />
                                                <div className="w-100">
                                                    <label>{t("instant-rebate.total-instant-rebate")}</label>
                                                    <p>
                                                        {this.state.loading ? (
                                                            <Skeleton count={1} />
                                                        ) : (
                                                            <>
                                                              <span>
                                                                <small>MYR</small> {parseFloat(this.state.total_instant_rebate).toFixed(2)}
                                                              </span>
                                                                <button type="button" className="btn btn-gradient-blue" onClick={this.handleClaimAll}>
                                                                {t('instant-rebate.claim-all')}
                                                                </button>
                                                            </>
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                      </div>
                                    }
                                    {this.state.pageShow === "instant-rebate-history" && 
                                    <div className="filters-col">
                                      <div className="filters-bt-panel">
                                          <div className="filters-bt-col">
                                              <label className="col-form-label">{t('history.date')}:</label>
                                              <div className="filters-group">
                                                  {filterDate &&
                                                      filterDate.map((item, index) => (
                                                          <div className="form-check form-check-inline filter" key={index}>
                                                              <input
                                                                  className="btn-check"
                                                                  type="radio"
                                                                  name="filterDate"
                                                                  id={item.id}
                                                                  value={item.value}
                                                                  onChange={(e) => { this.onChangeFilterDateHandler(index, e); this.filterDayRange(item.value); }}
                                                                  checked={index === this.state.currentFilterDate}
                                                              />
                                                              <label className="btn form-check-label" htmlFor={item.id} style={{ maxWidth: '75px' }}>
                                                                  {t(`history.${item.label}`)}
                                                              </label>
                                                          </div>
                                                      ))}
                                              </div>
                                          </div>
                                          <div className="filters-bt-col">
                                              <label className="col-form-label">
                                                  {t('referral.time')}:
                                              </label>
                                              <div className="input-group right">
                                                  <DateTimePicker
                                                      id="transaction_date"
                                                      name="transaction_date"
                                                      className="form-control"
                                                      autoUpdateInput={true}
                                                      autoApply={true}
                                                      format="MM/DD/YYYY"
                                                      value={this.state.transaction_date}
                                                      onChange={this.onInputChange}
                                                  />
                                                  <span className="input-group-text">
                                                      <Icon icon="uil:calendar-alt" />
                                                  </span>
                                              </div>
                                              <Button
                                                  typeButton="button"
                                                  classValue="btn btn-gradient-blue"
                                                  idValue="search"
                                                  buttonName={t('global.check')}
                                                  clicked={() => this.searchHandler(this.state.historyTab)}
                                                  disabled={this.state.disableSearchButton}
                                              />
                                              <div className="reset-btn">
                                                  <img className={`${this.state.spin ? "spin" : ""} `} src={icon["rotate-icon.svg"]} alt="reset" onClick={this.onResetHandler} />
                                              </div>
                                          </div>
                                      </div>
                                    </div>
                                    }
                                  </div>
                                </div>
                            </div>
                            <div className="pd-card-col">
                              {this.state.pageShow === "instant-rebate" &&
                              <Rebate
                                tabName='rebate'
                                // data={this.state.deposit}
                                datatablesChangeHandler={(val, tab, act) => this.datatablesChangeHandler(val, tab, act)}
                                setTotalRebate={this.setTotalRebate}
                                {...this.props}
                              /> }
                              {this.state.pageShow === "instant-rebate-history" && (
                              <History
                                tabName="history"
                                datatablesChangeHandler={this.datatablesChangeHandler}
                                {...this.state}
                              /> 
                              )}
                            </div>
                        </div>
                      </div>
                  </Reveal>
              </div>
          </section>
        ) : (
          <MobileInstantRebate
            filterDate={filterDate}
            filterDayRange={this.filterDayRange}

            datatablesChangeHandler={(val, tab, act) => this.datatablesChangeHandler(val, tab, act)}
            setTotalRebate={this.setTotalRebate}
            searchHandler={this.searchHandler}
            handleClaimAll={this.handleClaimAll}
            
            onChangeDateHandler={this.onChangeDateHandler}
            toggleShowDateSelect={this.toggleShowDateSelect}

            onResetHandler={this.onResetHandler}
            onChangeFilterDateHandler={this.onChangeFilterDateHandler}

            {...this.props}
            {...this.state}
          />
        )}
      </Auxiliary>
    );
  }
}



// Wire up redux so we can dispatch getList on mount
const mapStateToProps = (state) => ({
//  totalInstantRebateData: state.instantRebate.total_instant_rebate_data || {},
});

const mapDispatchToProps = {
  funcGetList: actions.getList,
  funcClaimAll: actions.claimAll,
  funcGetHistoryList: actions.getHistory, 
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(InstantRebate));

//export default withNamespaces("translation")(InstantRebate);
